module.exports = __webpack_public_path__ + "static/media/nokia.a5c0e25c.svg";